import { render, staticRenderFns } from "./contractUs.vue?vue&type=template&id=1a40d6c2&scoped=true&"
import script from "./contractUs.vue?vue&type=script&lang=js&"
export * from "./contractUs.vue?vue&type=script&lang=js&"
import style0 from "./contractUs.vue?vue&type=style&index=0&id=1a40d6c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40d6c2",
  null
  
)

export default component.exports